import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { useFlowStore } from "../../store/FlowStateStore.ts";
import { CanvasNodeData } from "../../models/CanvasNode.ts";
import LinkHandler from "./LinkHandler.tsx";
import ProductListDialog from "./ProductListDialog.tsx";
import { ShoppingBag } from "lucide-react";

const ProductList: React.FC<any> = (data) => {
    const { nodes } = useFlowStore();
    const [showDialog, setShowDialog] = useState(false);

    const [body, setBody] = useState("");
    const [productCount, setProductCount] = useState(0);
    const [sectionCount, setSectionCount] = useState(0);

    useEffect(() => {
        const node = nodes.find((n) => n.data.id === data.nodeId);
        if (!node) return;
        const content = (node.data as CanvasNodeData).content.find((c) => c.id === data.subNodeId);
        if (!content?.data) return;
        const d = content.data as any;
        const sections = d.sections ?? [];
        setBody(d.body || "");
        setSectionCount(sections.length);
        setProductCount(sections.reduce((total: number, s: any) => total + (s.products?.length ?? 0), 0));
    }, [nodes]);

    return (
        <div style={{ padding: "8px", display: "flex", flexDirection: "column", gap: "8px" }}>
            <div style={{
                background: "#f8fafc", borderRadius: "10px", padding: "10px 12px",
                border: "1px solid #e2e8f0", display: "flex", alignItems: "center", gap: "10px",
            }}>
                <div style={{
                    width: "32px", height: "32px", borderRadius: "8px", background: "#dcfce7",
                    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                }}>
                    <ShoppingBag size={16} color="var(--primary-bg-color)" />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: "11px", fontWeight: 600, color: "#0f172a", marginBottom: "2px" }}>
                        {productCount > 0
                            ? `${productCount} product${productCount !== 1 ? "s" : ""} · ${sectionCount} section${sectionCount !== 1 ? "s" : ""}`
                            : "No products selected"}
                    </div>
                    {body ? (
                        <div style={{ fontSize: "10px", color: "#64748b", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {body}
                        </div>
                    ) : (
                        <div style={{ fontSize: "10px", color: "#f59e0b" }}>Body text not set</div>
                    )}
                </div>
            </div>

            <button
                onClick={() => setShowDialog(true)}
                style={{
                    width: "100%", padding: "7px 0", fontSize: "12px", fontWeight: 500,
                    borderRadius: "8px", border: "1px solid var(--primary-bg-color)",
                    background: "white", color: "var(--primary-bg-color)", cursor: "pointer",
                }}
            >
                Configure Products
            </button>

            <LinkHandler />

            <Dialog
                header="Product List"
                visible={showDialog}
                modal
                appendTo={document.body}
                maskStyle={{ background: "rgba(0,0,0,0.5)", zIndex: 9998 }}
                contentStyle={{ zIndex: 9999, padding: "16px 20px" }}
                style={{ width: "560px", maxWidth: "95vw" }}
                onHide={() => setShowDialog(false)}
            >
                <ProductListDialog data={data} onClose={() => setShowDialog(false)} />
            </Dialog>
        </div>
    );
};

export default ProductList;
